import type { Config, NodeEnv } from './types'

export function getEnvVar<T extends boolean>(
    key: string,
    params: {
        isRequired?: T
    },
): T extends true ? string : string | undefined {
    const value = import.meta.env[key]
    if ((params.isRequired ?? true) && value == null) {
        if (process.env.NODE_ENV !== 'test') {
            throw new Error(`Required env var was not set: ${key}`)
        }
    }
    return value
}

export interface ConfigServiceDeps {}

export class ConfigService {
    config: Config

    constructor(private readonly deps: ConfigServiceDeps) {
        this.config = {
            firebaseAuth: {
                scopes: [
                    'https://www.googleapis.com/auth/gmail.readonly',
                    'https://www.googleapis.com/auth/userinfo.email',
                    'https://www.googleapis.com/auth/userinfo.profile',
                    'https://www.googleapis.com/auth/drive.file', // Needed for creating folders+uploading files
                ],
                clientId: getEnvVar('VITE_GOOGLE_CLIENT_ID', {
                    isRequired: true,
                }),
            },
            environment: {
                nodeEnv: getEnvVar('MODE', { isRequired: true }) as NodeEnv,
            },
            invoiceProcessor: {
                pdfProcessingQueuePersistencePath: 'pdf-processing-queue',
                emailCrudeProcessingQueuePersistencePath:
                    'email-crude-processing-queue',
                emailProcessingQueuePersistencePath: 'email-processing-queue',
            },
            searchProcessor: {
                stateFilePath: 'email-importer-state',
            },
        }
    }

    getConfig<T extends keyof Config>(key: T): Config[T] {
        return this.config[key]
    }
}
